module.exports = __webpack_public_path__ + "static/media/39.fa4479d2.jpg";